import { withStyles, Container } from "@material-ui/core";
import React, { useEffect } from "react";
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import styles from "./styles";
import * as generalActions from "../../actions/general";
import Breadcrumbs from '../../components/Breadcrumbs';
import Seo from "../../components/Seo";

function AboutUs(props) {
  const {aboutUsAction, classes, aboutUs} = props;
  const { fetchAboutUs } = aboutUsAction;

  useEffect(() => {
    fetchAboutUs();

    return () => {
      fetchAboutUs()
    }
  }, [fetchAboutUs])

  const mapParams = () => {
    let params = [{ name: "Về chúng tôi", cate: "about-us", to: "/ve-chung-toi"}];

    return params;
  }

  const seoData = {
    seo_title: "Về chúng tôi | WASTH thiết kế website và mobile app",
    seo_description: "Với mong muốn có thể  làm cho khách hàng hài lòng với mọi dịch vụ của công ty, đảm bảo chất lượng tốt nhất và sử dụng lâu dài",
    name: "Công ty TNHH thiết kế và lập trình website, mobile app WASTH"
  }

  return (
    <div>
      <Seo seoContent={seoData}/>
      <Container maxWidth="xl">
        <Breadcrumbs params={mapParams()} />
        <div className={ classes.about } dangerouslySetInnerHTML={{ __html: aboutUs }}>
      </div>
      </Container>
    </div>
  );
}

const mapStateToProps = state => {
  return {
    aboutUs:  state.general.aboutUs,
  }
};

const mapDisPatchToProps = dispatch => {
  return {
    aboutUsAction: bindActionCreators(generalActions, dispatch)
  }
};

const withConnect = connect(mapStateToProps, mapDisPatchToProps);

export default compose(withStyles(styles), withConnect)(AboutUs);